<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';

    defineOptions({
        inheritAttrs: false,
    });

    interface Props {
        className?: HTMLAttributes['class'];
    }

    defineProps<Props>();
</script>

<template>
    <svg
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="className"
    >
        <path
            d="M8.87182 16.5981C12.667 16.5981 15.7436 13.5215 15.7436 9.72631C15.7436 5.93111 12.667 2.85449 8.87182 2.85449C5.07662 2.85449 2 5.93111 2 9.72631C2 13.5215 5.07662 16.5981 8.87182 16.5981Z"
            fill="#003E52"
        />
        <path
            d="M12.1627 13.9556C11.7198 13.1171 8.8717 12.5908 8.8717 12.5908C8.8717 12.5908 6.02374 13.117 5.58078 13.9556C5.25336 15.1193 4.97949 16.5977 4.97949 16.5977H12.764C12.764 16.5977 12.579 15.0125 12.1627 13.9556Z"
            fill="#F1C9A5"
        />
        <path
            d="M8.87207 12.5908C8.87207 12.5908 11.7201 13.117 12.163 13.9556C12.5794 15.0124 12.7643 16.5977 12.7643 16.5977H8.87207V12.5908Z"
            fill="#E4B692"
        />
        <path
            d="M9.6473 10.8857H8.09668V13.4808H9.6473V10.8857Z"
            fill="#F1C9A5"
        />
        <path
            d="M9.64738 10.8857H8.87207V13.4808H9.64738V10.8857Z"
            fill="#E4B692"
        />
        <path
            opacity="0.1"
            d="M8.09668 12.0883C8.23613 12.4886 8.79892 12.718 9.21224 12.718C9.3601 12.7176 9.50696 12.6937 9.6473 12.6471V10.8857H8.09668V12.0883Z"
            fill="#DDAC8C"
        />
        <path
            d="M10.8661 9.24864C10.8661 7.62776 9.97351 6.70605 8.87249 6.70605C7.77148 6.70605 6.87891 7.62761 6.87891 9.24864C6.87891 11.4289 7.77148 12.1837 8.87249 12.1837C9.97351 12.1837 10.8661 11.3379 10.8661 9.24864Z"
            fill="#F1C9A5"
        />
        <path
            d="M10.5624 10.3725C10.201 10.3346 9.95703 9.94537 10.0182 9.50326C10.0793 9.06115 10.4208 8.73243 10.7825 8.77002C11.1442 8.80761 11.3873 9.19683 11.3263 9.63924C11.2654 10.0816 10.9238 10.4099 10.5624 10.3725Z"
            fill="#E4B692"
        />
        <path
            d="M6.43222 9.63924C6.37118 9.19683 6.61485 8.80761 6.97573 8.77002C7.33662 8.73243 7.67974 9.0608 7.74043 9.50326C7.80112 9.94572 7.55739 10.3347 7.19626 10.3725C6.83513 10.4103 6.49281 10.0816 6.43222 9.63924Z"
            fill="#F1C9A5"
        />
        <path
            d="M10.8657 9.24864C10.8657 7.62776 9.97309 6.70605 8.87207 6.70605V12.1836C9.97304 12.1836 10.8657 11.3379 10.8657 9.24864Z"
            fill="#E4B692"
        />
        <path
            d="M12.1627 13.9557C11.904 13.466 10.8259 13.0831 9.97307 12.8491L8.8718 16.598L7.77048 12.8491C6.91772 13.0831 5.83955 13.466 5.58078 13.9557C5.25336 15.1193 4.97949 16.5978 4.97949 16.5978H12.764C12.764 16.5978 12.5793 15.0126 12.1627 13.9557Z"
            fill="#003E52"
        />
        <path
            d="M7.73535 12.8491L8.87205 16.598L9.97755 12.8491L8.87205 14.1081L7.73535 12.8491Z"
            fill="#F1F2F2"
        />
        <path
            d="M8.87207 16.598L10.555 14.7235L9.97757 14.5048L10.9823 13.1401L10.0059 12.8491L8.87207 16.598Z"
            fill="#003E52"
        />
        <path
            d="M8.87201 16.598L7.18893 14.7235L7.76641 14.5048L6.76172 13.1401L7.73803 12.8491L8.87201 16.598Z"
            fill="#003E52"
        />
        <path
            d="M7.44531 14.3728L8.30703 13.5718L8.87068 14.108L8.09657 12.7637L7.62392 12.8C7.59 13.3227 7.44531 14.3728 7.44531 14.3728Z"
            fill="white"
        />
        <path
            d="M10.2963 14.3728L9.43464 13.5718L8.87109 14.1083L9.645 12.7637L10.1177 12.8C10.1516 13.3227 10.2963 14.3728 10.2963 14.3728Z"
            fill="white"
        />
        <path
            d="M11.0607 8.88333C11.0607 8.88333 10.7052 8.61514 10.553 9.40233C10.6024 8.66255 10.5665 7.64215 9.96618 7.45545C9.63268 8.05547 8.31264 8.44182 7.44579 8.22874C7.51232 8.90894 7.31253 9.46916 7.08571 9.61571C7.099 9.06887 7.0988 8.73542 6.75211 8.84221C6.6589 7.6954 7.28696 6.2417 8.98061 6.2417C10.6743 6.2417 11.234 7.38952 11.0607 8.88333Z"
            fill="#262421"
        />
        <path
            d="M8.87207 1.9043C13.1918 1.90443 16.6934 5.40677 16.6934 9.72656C16.6932 14.0462 13.1917 17.5477 8.87207 17.5479C4.55228 17.5479 1.04994 14.0463 1.0498 9.72656C1.0498 5.40669 4.5522 1.9043 8.87207 1.9043Z"
            stroke="currentColor"
            stroke-width="1.9"
        />
    </svg>
</template>
